import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useRef } from 'react';
import { ReactComponent as Calendar } from '../../assets/Calendar.svg';
import { Container } from '../Container';
import { MenuItem, FormControl, Select } from '@mui/material';
import { useTypedTheme } from '@monorepo-web/styles';
import ModalPersonalizado from './ModalPersonalizado';
import { checkPeriodoPersonalizado } from '@monorepo-web/utils';
export default function Periodo({ periodo, obj_datas, disabled, onChange, dataInicialCarteira, dataFinalCarteira, onSelectAplicar, }) {
    const theme = useTypedTheme();
    function getOptionFromPeriodo(periodo) {
        return checkPeriodoPersonalizado(periodo !== null && periodo !== void 0 ? periodo : "")
            ? "personalizado"
            : periodo !== null && periodo !== void 0 ? periodo : "";
    }
    const [option, setOption] = useState(getOptionFromPeriodo(periodo));
    const [openModal, setOpenModal] = useState(false);
    const [containerHeight, setContainerHeight] = useState(162);
    const ref = useRef(null);
    useEffect(() => {
        setOption(getOptionFromPeriodo(periodo));
    }, [periodo]);
    useEffect(() => {
        if (ref && ref.current && ref.current.offsetTop) {
            setContainerHeight(ref.current.offsetTop);
        }
    }, []);
    function MenuItemStyles() {
        return {
            backgroundColor: theme.dropSelectorColor,
            color: theme.backgroundColorSecondary,
            fontFamily: 'Roboto !important',
            marginTop: -8,
            marginBottom: -8,
        };
    }
    const menuItemOptions = [
        { label: 'Desde o início', value: 'maximo' },
        { label: 'No mês', value: 'mes_atual' },
        { label: '1 ano', value: '12m' },
        { label: '2 anos', value: '24m' },
        { label: '3 anos', value: '36m' },
        { label: 'Personalizado', value: 'personalizado' },
    ];
    const handleChange = (event) => {
        const { target: { value }, } = event;
        setOption(value);
        if (value !== 'personalizado') {
            onChange(value);
        }
    };
    const handleSelectPersonalizado = () => {
        setOpenModal(true);
    };
    return (_jsxs(Container, { children: [_jsx(FormControl, Object.assign({ ref: ref, variant: "standard", style: { display: 'flex', flexDirection: 'row' } }, { children: _jsx(Select, Object.assign({ disabled: disabled, displayEmpty: true, value: option, onChange: handleChange, renderValue: (selected) => {
                        var _a, _b;
                        const select = (_b = (_a = menuItemOptions.filter((obj) => obj.value === selected)[0]) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : false;
                        if (!select) {
                            return _jsx("div", Object.assign({ style: { color: theme.titleFontColor } }, { children: "Per\u00EDodo" }));
                        }
                        return _jsx("div", Object.assign({ style: { color: theme.titleFontColor } }, { children: select }));
                    }, inputProps: {
                        'aria-label': 'Without label',
                        IconComponent: () => (_jsx(Calendar, { width: "25px", fill: disabled ? theme.disabledColor : theme.iconsColor })),
                    } }, { children: menuItemOptions.map((item) => (_jsx(MenuItem, Object.assign({ style: MenuItemStyles(), value: item.value, onClick: item.value === 'personalizado' ? handleSelectPersonalizado : () => null }, { children: item.label }), item.value))) })) })), _jsx(ModalPersonalizado, { openModal: openModal, setOpenModal: setOpenModal, containerHeight: containerHeight, obj_datas: obj_datas, dataInicialCarteira: dataInicialCarteira, dataFinalCarteira: dataFinalCarteira, onSelectAplicar: onSelectAplicar })] }));
}
export { default as CalendarioField } from './Calendario';
export { default as DataFim } from './DataFim';
export { default as ModalPersonalizado } from './ModalPersonalizado';
